<script>
  import { Pie } from 'vue-chartjs'


  export default {
    extends: Pie,
    data () {
      return {
        chartData: {
          labels: ["ערבים", "יהודים"],
          datasets: [{
              borderWidth: 1,
              borderColor: [
              'rgba(204,0,0,1)',
              'rgba(0, 0, 153, 1)',         
              ],
              backgroundColor: [
              'rgba(255,153,51, 0.9)',
              'rgba(51, 153, 255, 0.9)',     
              ],
              data: this.cData
            }]
        },
        options: {
          legend: {
            display: true
          },
          responsive: true,
          maintainAspectRatio: false
        }
      }
    },
    props: ['cData'],
    mounted () {
      this.chartData.data = this.cData;
      this.renderChart(this.chartData, this.options)
    },
    watch: {
    cData(){
        if (this.cData.length) {
            this.renderChart({
          labels: ["ערבים", "יהודים"],
          datasets: [{
              borderWidth: 1,
              borderColor: [
              'rgba(204,0,0,1)',
              'rgba(0, 0, 153, 1)',         
              ],
              backgroundColor: [
              'rgba(255,153,51, 0.9)',
              'rgba(51, 153, 255, 0.9)',     
              ],
              data: this.cData
            }]
            }, {responsive: true, maintainAspectRatio: false})
        }else{
            this._chart.destroy()
        }
    }
}
  }
</script>